// frontend/src/components/PrivateRoute.js
import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';

const PrivateRoute = ({ component: Component, permission, allowedRoleIds }) => {
    const { authenticated, permissions, user, profileLoading } = useContext(AuthContext);

    if (!authenticated) {
        return <Navigate to="/login" />;
    }

    if (profileLoading) {
        return null;
    }

    if (allowedRoleIds && (!user || !allowedRoleIds.includes(Number(user.RoleId)))) {
        return <Navigate to="/access-denied" />;
    }

    if (permission && !permissions.includes(permission)) {
        return <Navigate to="/access-denied" />;  // Redirect to access-denied if permission is missing
    }

    return <Component />;
};

export default PrivateRoute;
